import type { AppointmentTransferStatus } from '@mend/types/appointment';
import type { Response } from '#types/common.ts';

import { api } from '#services/http-clients.ts';

export function getAppointmentStatuses(): Promise<AppointmentTransferStatus[]> {
  return api
    .get<Response<{ appointmentStatuses: AppointmentTransferStatus[] }>>('/appointment-status')
    .then((response) => response.data.payload.appointmentStatuses);
}
